"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const avatar_module_scss_1 = __importDefault(require("./avatar.module.scss"));
const Avatar = (_a) => {
    var { src = 'https://cgcdn.s3.amazonaws.com/global-ui/images/avatars/placeholder.png', alt = 'user image', size = '48px', className = '', style = {} } = _a, props = __rest(_a, ["src", "alt", "size", "className", "style"]);
    return (react_1.default.createElement("img", Object.assign({ src: src, className: `${avatar_module_scss_1.default.avatar} ${className}`, style: Object.assign({ width: size, height: size }, style) }, props)));
};
Avatar.propTypes = {
    src: prop_types_1.default.string,
    alt: prop_types_1.default.string,
    size: prop_types_1.default.string,
    className: prop_types_1.default.string,
    style: prop_types_1.default.object,
};
exports.default = (0, react_1.memo)(Avatar);
//# sourceMappingURL=avatar.js.map